var map = {
	"./NullComponent.vue": 9610,
	"./background-components/backgroundMedia.vue": 3451,
	"./background-components/backgroundPresenter.vue": 6817,
	"./background-components/backgroundText.vue": 3461,
	"./content-components/contentSidescroll.vue": 8631,
	"./content-components/contentTabs.vue": 8541,
	"./content-components/externalLink.vue": 3795,
	"./content-components/fullscreenIframePlayer.vue": 5231,
	"./content-components/fullscreenVideo.vue": 2127,
	"./content-components/mail.vue": 5030,
	"./content-components/segment-components/Breadcrumbs.vue": 7572,
	"./content-components/segment-components/Segment.vue": 4568,
	"./content-components/segment-components/segment-content/bodyText.vue": 6931,
	"./content-components/segment-components/segment-content/headlineBig.vue": 6806,
	"./content-components/segment-components/segment-content/headlineMedium.vue": 4601,
	"./content-components/segment-components/segment-content/headlineSmall.vue": 8710,
	"./content-components/segment-components/segment-content/imageSegment.vue": 716,
	"./content-components/segment-components/segment-content/subheadline.vue": 5272,
	"./content-components/segment-components/segment-content/videoSegment.vue": 6011
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9902;